const storeContents = {
  uk: {
    href: "https://cart.wearewild.com",
    name: "UNITED KINGDOM",
    flag: "🇬🇧",
  },
  us: {
    href: "https://cart.wilddeo.com",
    name: "UNITED STATES",
    flag: "🇺🇸",
  },
  au: { href: "https://cart.wildrefill.co", name: "AUSTRALIA", flag: "🇦🇺" },
  eu: { href: "https://cart.wildrefill.com", name: "EUROPE", flag: "🇪🇺" },
};

async function searchStoresByEmail(email,isRechargePage,password) {

  const emailPattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  if (!email || !emailPattern.test(email) || !password & !isRechargePage) {
    return handleError(isRechargePage, "validation");
  }

  try {
    setSpinnerModal(true);
    const response = await fetch(
      `https://wild-services.vercel.app/customers/lookup/${email}?withSubscriptions=true`
    );
    setSpinnerModal(false);
    if (response.status == 200) {
      const data = await response.json();
      const arrayOfStores = Object.values(data).map(function (key) {
        return key;
      });
      if (arrayOfStores.length < 1) {
        handleError(isRechargePage);
      } else {
        showModal(arrayOfStores, email,isRechargePage);
      }
    } else {
      handleError(isRechargePage);
    }
  } catch (err) {
    console.log(err)
    setSpinnerModal(false);
    handleError(isRechargePage);
  }
}

function buildLoginButton(item, email) {
  const store = item.store;
  const storeHref = storeContents[store].href;
  const storeName = storeContents[store].name;
  const storeFlag = storeContents[store].flag;
  const isEnabled = item.state === 'ENABLED'
  const currentStore = JSON.stringify(wildThemeTranslations.currentStore);

  const selectedStore = JSON.stringify(store);

  return `
      <button ${!isEnabled ? 'disabled' : ''} data-test-id="redirectToCorrectStoreButton" data-store-id="redirectToCorrectStoreButton-${store}" class="lgn-btn" onclick='handleUserSelect("${storeHref}",${JSON.stringify(email)},${isRechargePage},${currentStore},${selectedStore},${isEnabled})' href="${storeHref}">
        ${
          item?.subscriptions?.active > 0
            ? `<span id="activeSub" class="lgn-btn-sub"> 🏖️  <span class="pr">${wildThemeTranslations.activeSub}</span></span>`
            : ""
        } 
        <span class="flag-name-root" id="storeCountry"> ${storeFlag} <span class="store-name">${storeName}</span> </span>
      </button>
      `;
}

function buildActivateAccountButton(item, email) {
  const store = item.store;
  const selectedStore = JSON.stringify(item);
  const storeFlag = storeContents[store].flag;
  return `<button data-store-id="activateAccountButton-${store}" class="lgn-btn" onclick='handleActivateAccount(${JSON.stringify(email)},${selectedStore})'>
        <span class="flag-name-root" id="storeCountry"> ${storeFlag} <span class="store-name">Activate Account</span> </span>
      </button>`
}

function handleActivateAccount(email, selectedStore) {
  fetch(`https://api.wearewild.com/customers/invite?dev=false&locale=${selectedStore.store}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      customerEmail: email,
      customerId: selectedStore.id
    })
  }).then(res => res.json()).then(data => {
    displayActivateAccountContent()
  })
}

function showModal(arrayOfStores, email, isRechargePage) {
  const modal = document.getElementById("redirectToCorrectStoreModal");
  const contentContainer = document.getElementById("modal-content");
  const currentStore = JSON.stringify(wildThemeTranslations.currentStore);

  if (arrayOfStores.length === 1 && arrayOfStores[0].state !== 'ENABLED') {
    handleActivateAccount(email, arrayOfStores[0])
    modal.style.display = "block";
    return
  }

  if(arrayOfStores.length === 1) {
    const userStore = arrayOfStores[0].store;
    if(currentStore === JSON.stringify(userStore)){
      return submitForm(isRechargePage)
    } else {
      return redirectToStore(storeContents[userStore].href,email,isRechargePage)
    }
  }

  let newContent = "";
  arrayOfStores.forEach(function (item) {
    newContent += `<div class="activate-account-root">`
    newContent += buildLoginButton(item, email)
    
    if (item.state !== 'ENABLED') {
      newContent = `
      ${newContent}
      ${buildActivateAccountButton(item, email)}
      `
    }
    newContent += `</div>`
  });

  contentContainer.innerHTML = newContent;
  modal.style.display = "block";
}

function setSpinnerModal(show = false) {
  const modal = document.getElementById("loadingSpinner");
  modal.style.display = show ? "block" : "none";
}

function closeModal() {
  const modal = document.getElementById("redirectToCorrectStoreModal");
  modal.style.display = "none";
}

function displayActivateAccountContent() {
  const modalContent = document.getElementById("modal-content")
  const headerText = document.getElementById("header-text")
  const headerSub = document.getElementById("header-sub")
  modalContent.innerHTML = ""
  headerSub.innerHTML = wildThemeTranslations.activateAccountDescription
  headerText.innerHTML = wildThemeTranslations.activateAccountTitle
}

function handleUserSelect(href, email, isRechargePage, currentStore, selectedStore, isEnabled) {
  closeModal()
  if(currentStore !== selectedStore) {
   redirectToStore(href, email, isRechargePage)
  } else {
   submitForm(isRechargePage)
  }
}

function redirectToStore(href, email, isRechargePage) {
  const redirectUrlMarkers = 'verified=true'
  let url = `${href}/account/login?use_password=true&form=login&${redirectUrlMarkers}&email=${email}`;
  if (isRechargePage) {
    url = `${href}/tools/recurring/get-subscription-access?form=recharge&${redirectUrlMarkers}&email=${email}`;
  }
  window.location.replace(url);
}

function submitForm(isRechargePage) {
  if(isRechargePage) {
    const btn = document.querySelector(".rc-login-form-button");
    const newButton = removeAllEventListeners(btn);
    newButton.click()
  } else {
    const loginButton = document.getElementById("loginBtnPwd")
    const newButton = removeAllEventListeners(loginButton);
    newButton.click()
  }
}

function removeAllEventListeners(element) {
  const newElement = element.cloneNode(true);
  element.parentNode.replaceChild(newElement, element);
  return newElement;
}

function autoSubmitForm(email, isRechargePage) {
  if (isRechargePage) {
    const loginButton = document.querySelector(".rc-login-form-button");
    const customerEmail = document.querySelector(".rc-login-form-email");
    customerEmail.value = email;
    loginButton.click();
  } else {
    const  customerEmail = document.getElementById("CustomerEmail"); 
    customerEmail.value = email;
  }
}

function handleError(
  isRechargePage,
  type = "full",
) {
  const errorCtaElement = document.getElementById("errorCtaRoot");
  const {
    validEmailError = "Please enter a valid email.", 
    noStoreError = "Sorry, we could not find your account. Try a different email, get started or contact us."
  } = wildThemeTranslations;

  if (isRechargePage) {
    const btn = document.querySelector(".rc-login-form-button");
    btn.setAttribute('disabled', true);
    btn.classList.add("error-btn-disabled");
    
    const errtext = document.querySelector(".rc-email-error");
    errtext.classList.remove("rc-hidden");
    errtext.classList.add("errorElement-text");

    if (type === "validation") {
      errtext.textContent = validEmailError;
      errtext.style.display = "block";
    } else {
      errorCtaElement.style.display = 'flex'
      errtext.innerHTML = `<div>
      <p class="errorElement-text">${noStoreError}</p>
      ${errorCtaElement.innerHTML}
      </div>`
    }
  } else {
    const loginButton = document.getElementById("loginBtnPwd");
    loginButton.setAttribute('disabled', true)
    loginButton.classList.add("error-btn-disabled")

    const errorElementText = document.getElementById("errorElementText")
    errorElementText.style.display = "block";
    errorElementText.classList.add("errorElement-text");

    if (type === "validation") {
      errorElementText.textContent = validEmailError;
    } else {
      errorElementText.textContent = noStoreError;
      errorCtaElement.style.display = "flex";
    }
  }
}

const clearErrors = (isRechargePage) => {
  const errorCtaElement = document.getElementById("errorCtaRoot");
  errorCtaElement.style.display = "none"

  if(isRechargePage) {
    const btn = document.querySelector(".rc-login-form-button");
    btn.removeAttribute('disabled');
    btn.classList.remove("error-btn-disabled")

    const errtext = document.querySelector(".rc-email-error");
    errtext.style.display = "block"
    errtext.textContent = "Sorry, we could not find your account";
    errtext.classList.add("rc-hidden");
    errtext.classList.add('errorElement-text')
  } else {
    const errorElementText = document.getElementById("errorElementText")
    errorElementText.style.display = "none";
    errorElementText.classList.remove('errorElement-text')

    const loginButton = document.getElementById("loginBtnPwd");
    loginButton.classList.remove("error-btn-disabled")
    loginButton.removeAttribute('disabled');
  }
}